"use client";
import { useState } from "react";
import DownArrow from "@/components/icons/down-arrow";
import Image from "next/image";

const Accordian = ({ faqs }) => {
  const [isOpen, setIsOpen] = useState(null);
  return (
    <ul className="px-5">
      {faqs.map((item, i) => {
        const isTrue = isOpen === item.question ? true : false;
        return (
          <div
            key={i}
            className={`my-4 lg:mb-8 rounded-lg text-base cursor-pointer group transition-all duration-500 ${
              isTrue ? "shadow-lg" : ""
            }`}
            onClick={() =>
              setIsOpen(isOpen === item.question ? null : item.question)
            }
          >
            <div
              className={`px-3 py-3 flex justify-between items-center rounded-lg transition-all duration-500 ease-in-out transform ${
                isTrue
                  ? "bg-green-12 text-white font-medium rounded-b-none"
                  : "bg-[#EDF0FF] text-green-1 font-semibold hover:bg-[#d9e3ff] hover:border hover:border-green-3 hover:shadow-md hover:lg:scale-[1.02]"
              }`}
            >
              {item.question}
              <button
                aria-label="arrow"
                className="cursor-pointer transform duration-500 hover:scale-125"
              >
                {isTrue ? (
                  <DownArrow className="w-7 h-7 bg-white text-green-1 rounded-full p-2 font-bold rotate-180 transition-transform duration-500" />
                ) : (
                  <DownArrow className="w-7 h-7 text-white bg-green-12 rounded-full p-2 font-bold transition-transform duration-500" />
                )}
              </button>
            </div>
            <div
              className={`overflow-auto bg-white text-gray-600 text-sm lg:text-base px-3 rounded-b-md transition-all duration-500 lg:duration-1000 delay-400 ease-in-out ${
                isTrue ? "h-fit py-3 " : "max-h-0 py-0"
              }`}
            >
              <div className="transition-opacity duration-400 delay-900 ease-in-out">
                <div className="flex flex-col lg:flex-row lg:items-start gap-4">
                  <div className="flex-1 space-y-2">
                    {Array.isArray(item.answer) ? (
                      item.answer.map((ans, idx) => (
                        <div
                          key={idx}
                          dangerouslySetInnerHTML={{ __html: ans }}
                        />
                      ))
                    ) : (
                      <div>{item.answer}</div>
                    )}
                  </div>

                  {item.image && (
                    <div className="flex-shrink-0 lg:max-w-[300px] w-full">
                      <Image
                        src={item.image}
                        alt={item.question}
                        width={300}
                        height={300}
                        className="rounded-lg w-62 h-62"
                      />
                    </div>
                  )}
                </div>

                {item.answerTable && (
                  <>
                    <div>{item.answerTable.title}</div>
                    <h4 className="font-semibold mt-4">
                      {item.answerTable.subTitle}:
                    </h4>
                    <div className="max-h-64 overflow-y-scroll">
                      <table className="table-auto border border-gray-300 mt-2 text-sm w-full">
                        <thead>
                          <tr>
                            {item.answerTable.table.headers.map(
                              (header, index) => (
                                <th key={index} className="border px-2 py-1">
                                  {header}
                                </th>
                              )
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {item.answerTable.table.rows.map((group, index) =>
                            group.services.map((service, subIndex) => (
                              <tr key={`${index}-${subIndex}`}>
                                {subIndex === 0 && (
                                  <td
                                    className="border px-2 py-1"
                                    rowSpan={group.services.length}
                                  >
                                    {group.category}
                                  </td>
                                )}
                                <td className="border px-2 py-1">
                                  {service.name || "-"}
                                </td>
                                <td className="border px-2 py-1">
                                  {service.charge}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <h4 className="font-semibold mt-4">
                        {item.answerTable.tableFooter}
                      </h4>
                      <div>{item.answerTable.tableFooterDesc}</div>
                      <h4 className="font-semibold mt-4">
                        {item.answerTable.tableFooter2}
                      </h4>
                      <ul className="list-disc list-inside ml-4">
                        {item.answerTable.list.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </ul>
  );
};
export default Accordian;
